import React from "react";

const defaultBehavior = {};

const LocalDataContext = React.createContext(defaultBehavior);

export default LocalDataContext;
